export default __webpack_public_path__ + "static/media/house.adf76c30.svg";